import merge from 'lodash.merge'
import { getDepartments } from '../../services/departments'
import { generateStoreHandler } from './constructors'

const departments = generateStoreHandler('departments', getDepartments)

const state = {

}

const getters = {

}

const actions = {

}

const mutations = {}

export default merge(
    departments,
    {
        namespaced: true,
        state,
        getters,
        actions,
        mutations,
    },
)



// WEBPACK FOOTER //
// ./src/store/modules/departments.js